import React, { ReactNode } from 'react'
import { Button, ButtonProps } from '@tecsinapse/cortex-react'
import clsx from 'clsx'

type PopoverActionItemProps = { children: ReactNode } & ButtonProps

export const PopoverActionItem = ({
  variant,
  children,
  className,
  ...props
}: PopoverActionItemProps) => {
  return (
    <Button
      variant={variant ?? 'text'}
      className={clsx(
        className,
        'p-deca rounded-none w-full flex flex-row space-x-mili justify-start items-center'
      )}
      {...props}
    >
      {children}
    </Button>
  )
}
